/**
 * Keep header cart count in sync after AJAX add-to-cart.
 * The badge must always exist in the DOM (see header.liquid) so it can be updated live.
 */
(function () {
  function ensureCartCountBadge() {
    var cartLink = document.querySelector('.Header__Icon-cart');

    if (!cartLink || cartLink.querySelector('.Header__CartCount')) {
      return;
    }

    var badge = document.createElement('span');
    badge.className = 'Header__CartCount is-empty';
    badge.setAttribute('data-count', '0');
    badge.textContent = '0';
    cartLink.appendChild(badge);
  }

  function updateCartCountElements(count) {
    document.querySelectorAll('.Header__CartCount').forEach(function (element) {
      element.textContent = count;
      element.setAttribute('data-count', count);
      element.classList.toggle('is-empty', count === 0);
    });
  }

  function syncHeaderCartCount() {
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        ensureCartCountBadge();
        updateCartCountElements(cart.item_count);
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', ensureCartCountBadge);
  document.addEventListener('product:added', syncHeaderCartCount);
  document.documentElement.addEventListener('cart:refresh', syncHeaderCartCount);
})();

/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */